import z from "zod";

import avatarMissingImage from "@/assets/images/placeholders/avatar-missing.png";

const carouselGroupSchema = z
  .object({
    group_id: z.string(),
    group_avatar: z.string().catch(avatarMissingImage),
    display_name: z.string(),
    id: z.string().catch(""),
    seen: z.boolean(),
  })
  .transform((carouselGroup) => {
    carouselGroup.id = carouselGroup.group_id;

    return carouselGroup;
  });

type CarouselGroup = z.infer<typeof carouselGroupSchema>;

export { carouselGroupSchema, type CarouselGroup };
